import { parse as parseYaml } from 'yaml';
import { validateContentFile, type SchemaIssue } from './schema';
import type { ContentFile } from './types';

export type ParseContentResult =
  | { ok: true; path: string; file: ContentFile }
  | { ok: false; path: string; stage: 'yaml' | 'schema'; errors: SchemaIssue[] };

/**
 * content の YAML 文字列を読み、schema で検証する（card-schema.md §1, §4 段階 1）。
 * ファイルの列挙（`import.meta.glob('/content/**\/*.yaml', { query: '?raw' })` など）は UI 層が行う。
 */
export function parseContentYaml(text: string, path = '<memory>'): ParseContentResult {
  let data: unknown;
  try {
    data = parseYaml(text);
  } catch (e) {
    return {
      ok: false,
      path,
      stage: 'yaml',
      errors: [{ instancePath: '/', message: e instanceof Error ? e.message : String(e) }],
    };
  }
  const checked = validateContentFile(data);
  if (!checked.ok) return { ok: false, path, stage: 'schema', errors: checked.errors };
  return { ok: true, path, file: checked.value };
}
